import { Component, Input } from '@angular/core';
import { WebsiteElementPreviewFragment } from '@/core/graphql/graphql';

@Component({
  selector: 'cosmos-website-element-preview',
  templateUrl: './website-element-preview.component.html',
  styleUrls: ['./website-element-preview.component.scss'],
})
export class WebsiteElementPreviewComponent {
  @Input() public isCompact = true;
  @Input() public set element (element: WebsiteElementPreviewFragment) {
    this.elementLink = element.url || '';
  }
  public elementLink: string;
}
